var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Scoreboards } from "../../../../../constants";
import { eBranches } from "sb-helpers";
import { Scoreboard } from "../../Scoreboard";
import { renderMiniTeamsScore } from "./renderMiniTeamsScore";
export var renderMiniScore = function (score1, score2, sportId, props) {
    return Scoreboards[eBranches[sportId]]
        ? React.createElement(Scoreboard, __assign({}, props))
        : renderMiniTeamsScore(score1, score2);
};
//# sourceMappingURL=renderMiniScore.js.map